var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomer = function SvgCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.994h2.333a2 2 0 0 0 1.2-.4l2.416-1.812a1.515 1.515 0 0 1 1.98 2.284l-2.073 2.073a4 4 0 0 1-2.044 1.094l-2.93.585c-.581.117-1.18.102-1.755-.042l-2.65-.662a3.962 3.962 0 0 0-.97-.12H7m6.002-3h1.485c.836 0 1.515-.678 1.515-1.515v-.3c0-.695-.473-1.3-1.147-1.469l-2.292-.573a4.69 4.69 0 0 0-3.744.646l-1.817 1.211H3.003v4.997h3.999M11.995 8.33a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.331Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.662 10.494v-.75.75Zm2.666 0v-.75.75Zm-4.581 4.998V13.16h-1.5v2.332h1.5Zm0-2.332c0-.508.201-.996.56-1.355l-1.06-1.06c-.64.64-1 1.509-1 2.415h1.5Zm.56-1.355c.36-.359.847-.56 1.355-.56v-1.5c-.906 0-1.774.359-2.415 1l1.06 1.06Zm1.355-.56h2.666v-1.5h-2.666v1.5Zm2.666 0c.508 0 .995.201 1.354.56l1.06-1.06c-.64-.641-1.508-1-2.414-1v1.5Zm1.354.56c.36.36.561.847.561 1.355h1.5c0-.906-.36-1.775-1-2.415l-1.06 1.06Zm.561 1.355v2.832h1.5V13.16h-1.5Z",
    fill: "currentColor"
  })));
};
export default SvgCustomer;